import {api} from "../services/Api";
import {Alert, Button} from "react-bootstrap";
import {copyToClipboard} from "./copyToClipboard";

export function downloadInvoice(document, phone, invoiceId, pix = false) {
	return new Promise((resolve, reject) => {
		api.post('/login',{
			documento: document,
			telefone: phone,
			codigo: process.env.REACT_APP_SUPERGER_API_CODIGO,
		}).then(result => {
			const headers = {
				'Authorization': 'Beaser '+result.data.dados.token,
				'Content-Type': 'application/json',
			};

			function downloadInvoice() {
				api.get('v1/pessoas/clientes/boleto/' + invoiceId, {responseType: 'blob', headers})
					.then((response) => {
						let newBlob = new Blob([response.data], {type: "application/pdf"})
						const data = window.URL.createObjectURL(newBlob);
						let link = window.document.createElement('a');
						link.href = data;
						link.download = "NetComet_Boleto_" + invoiceId + ".pdf";
						link.click();
						setTimeout(function () {
							window.URL.revokeObjectURL(data);
						}, 100);
					}).catch(() => {
						alert('Problema ao baixar o boleto!')
					})
			}

			function downloadLinhaDigitavel() {
				api.get('v1/pessoas/clientes/linha-digitavel-boleto/'+invoiceId, { headers })
					.then((response) => {
						try {
							copyToClipboard(response.data.dados);
							alert('Código copiado com sucesso!')
						} catch (e) {
							alert('Problema ao copiar código do boleto!')
						}
					}).catch(() => {
						alert('Problema ao buscar código do boleto!')
					});
			}

			function downloadQrCodeBoleto() {
				api.get('v1/pessoas/clientes/qrcode-boleto/'+invoiceId, { headers })
					.then((response) => {
						try {
							copyToClipboard(response.data.dados);
							alert('Pix copiado com sucesso!')
						} catch (e) {
							alert('Problema ao copiar código do boleto!')
						}
					}).catch(() => {
					alert('Problema ao buscar código do boleto!')
				});
			}

			resolve(
				<>
					<Button
						variant="light"
						className="justify-content-center align-items-center d-flex w-100"
						onClick={() => {
							downloadInvoice();
						}}
					>
						<span className="material-icons title-icon">download</span>
						Clique para Baixar o Boleto
					</Button>
					{pix && <>
						<Button
							variant="light"
							className="mt-3 justify-content-center align-items-center d-flex w-100"
							onClick={() => {
								downloadQrCodeBoleto();
							}}
						>
							<span className="material-icons title-icon">pix</span>
							Pagar via Pix
						</Button>
					</>}
					{!pix && <>
						<Button
							variant="light"
							className="mt-3 justify-content-center align-items-center d-flex w-100"
							onClick={() => {
								downloadLinhaDigitavel();
							}}
						>
							<span className="material-icons title-icon">content_copy</span>
							Clique para Copiar Código do Boleto
						</Button>
					</>}
				</>
			)
		}).catch(error => {
			reject(<Alert variant="danger">{error.response.data.message}</Alert>);
		})
	})
}
